import { v4 } from 'uuid';

const jsonMimeType = 'application/json';
const acceptJson = {
    Accept: jsonMimeType
};
const postJson = {
    'Content-Type': jsonMimeType
};
const authHeader = (accessToken)=>({
        Authorization: `Bearer ${accessToken}`
    })
;
const correlationHeader = ()=>{
    return {
        'X-Correlation-ID': v4()
    };
};

export { acceptJson, authHeader, correlationHeader, postJson };
//# sourceMappingURL=shared.js.map
